import { FC, useMemo } from 'react';
import { useAppFlagStore } from '@frontend/shared';
import { useEligibility } from '@frontend/user-preferences';
import { PATIENT_INSIGHT_TEASER_VARIANT_B_FF } from '../../constants';
import { PatientInsightTeaserVariantA } from './patient-insight-teaser-variant-a';
import { PatientInsightTeaserVariantB } from './patient-insight-teaser-variant-b';

export interface PatientInsightTeaserProps {
  locationId?: string;
  onViewDemo?: () => void;
}

export const PatientInsightTeaser: FC<PatientInsightTeaserProps> = ({ locationId, onViewDemo }) => {
  const { getFeatureFlagValue } = useAppFlagStore();
  const { recordDismiss, shouldShow } = useEligibility({
    featureId: 'patient-insight-teaser',
    defaultCriteria: {
      type: 'dismiss-cooldown',
      maxDismisses: 3,
      cooldownDays: 28,
    },
  });

  const isVariantBEnabled = useMemo(
    () =>
      locationId
        ? getFeatureFlagValue({
            flagName: PATIENT_INSIGHT_TEASER_VARIANT_B_FF,
            locationIds: [locationId],
          })
        : false,
    [getFeatureFlagValue, locationId]
  );

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      {isVariantBEnabled ? (
        <PatientInsightTeaserVariantB onViewDemo={onViewDemo} onDismiss={recordDismiss} locationId={locationId} />
      ) : (
        <PatientInsightTeaserVariantA onViewDemo={onViewDemo} onDismiss={recordDismiss} locationId={locationId} />
      )}
    </>
  );
};
